import { ShieldCheck, Wrench, Siren, UserCheck, CarFront, Scale, HeartPulse, CloudLightning, Check } from "lucide-react";
import { INCLUDED } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const ICONS = { ShieldCheck, Wrench, Siren, UserCheck, CarFront, Scale, HeartPulse, CloudLightning };

export const WhatsIncluded = ({ dark = false }) => (
  <section className={dark ? "bg-xmove-night py-16 lg:py-24" : "mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24"} data-testid="whats-included">
    <div className={dark ? "mx-auto max-w-7xl px-5 lg:px-8" : ""}>
      <Reveal>
        <p className={`text-xs font-semibold uppercase tracking-widest ${dark ? "text-xmove-orange" : "text-xmove-orange"}`}>Tutto incluso</p>
        <h2 className={`mt-3 max-w-2xl font-display text-3xl font-bold sm:text-4xl ${dark ? "text-white" : "text-xmove-ink"}`}>
          Un canone. Zero pensieri.
        </h2>
        <p className={`mt-3 max-w-2xl text-base md:text-lg ${dark ? "text-white/60" : "text-xmove-muted"}`}>
          Ogni offerta XMOVE include sempre questi servizi. L'unico costo extra è il carburante (o la ricarica).
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {INCLUDED.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.name} delay={i * 0.06} className="h-full">
              <div className={`h-full rounded-2xl p-5 text-center transition-all duration-300 hover:-translate-y-1 ${dark ? "bg-white/5 hover:bg-white/10" : "border border-xmove-ink/8 bg-white shadow-soft hover:shadow-lift"}`}>
                <span className={`mx-auto flex h-11 w-11 items-center justify-center rounded-xl ${dark ? "bg-xmove-orange/20 text-xmove-orange" : "bg-xmove-orange/12 text-xmove-orange"}`}>
                  <Icon size={20} />
                </span>
                <h3 className={`mt-3.5 text-sm font-bold ${dark ? "text-white" : "text-xmove-ink"}`}>{s.name}</h3>
                <p className={`mt-1.5 hidden text-xs leading-relaxed sm:block ${dark ? "text-white/50" : "text-xmove-muted"}`}>{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.2}>
        <p className={`mt-8 flex items-center gap-2 text-sm font-medium ${dark ? "text-white/70" : "text-xmove-ink"}`}>
          <Check size={16} className="text-xmove-green" /> Nessun costo nascosto: se non è scritto nel preventivo, non lo paghi.
        </p>
      </Reveal>
    </div>
  </section>
);
